<svelte:options customElement="clever-search-cb" />

<script lang="ts">
  /** stores */
  import { ConfigStore } from './lib/store/config';
  import {
    state_showSearch,
    state_fullScreen,
    state_showContactForm,
  } from './lib/store/state';
  /** others */
  import { fade, fly } from 'svelte/transition';
  import { WidgetType } from './lib/enums/widget-type.enum';
  import { shadowDomUpdates } from './lib/helpers/shadowdom-updates';
  import { onDestroy, onMount } from 'svelte';

  import ChatBotHeader from './lib/components/chat-bot-header.svelte';
  import { SessionStoreHandler } from './lib/helpers/session-storage-handler';
  import { WindowsCustomEventTypes } from './lib/enums/windows-custom-event.enum';
  import HeaderContactTheme from './lib/components/themes/header-contact-theme.svelte';
  import ContactWindow from './lib/components/themes/contact-window.svelte';
  import { getThemeSettings } from './lib/helpers/customize-theme';
  import { ColorThemeType } from './lib/enums/themes/color-theme-type.enum';

  // $ConfigStore = {
  //   ...$ConfigStore,
  //   widgetType: WidgetType.cb,
  // };

  let chatbotBottom: string | undefined = undefined;

  const handleKeyboardAdjust = (e: Event) => {
    const ua = navigator.userAgent;
    const isAndroid = /android/i.test(ua);
    // wv = standard WebView; FBAN/FBAV/Instagram = in-app browsers that don't report keyboard height via visualViewport
    const isAndroidWebView =
      isAndroid && (/; wv\)/i.test(ua) || /FBAN|FBAV|Instagram/.test(ua));
    if (!isAndroidWebView) return;
    const focused = (e as CustomEvent).detail?.focused;
    if (focused) {
      setTimeout(() => {
        // Messenger/Instagram: visualViewport shrinks when keyboard appears — use it as the true available height
        const viewportHeight =
          window.visualViewport?.height ?? window.innerHeight;
        chatbotBottom = `${Math.round(viewportHeight) + 10}px`;
      }, 500);
    } else {
      chatbotBottom = undefined;
    }
  };

  onMount(() => {
    shadowDomUpdates('clever-search-cb', true);

    window.addEventListener(
      WindowsCustomEventTypes.keyboardAdjust,
      handleKeyboardAdjust
    );

    if ($ConfigStore?.customTheme?.colorThemeType) {
      getThemeSettings($ConfigStore?.customTheme?.colorThemeType);
    } else {
      getThemeSettings(ColorThemeType.DEFAULT);
    }
    // state_showContactForm.set($ConfigStore.showContactWindow);

    if (
      $ConfigStore.showContactWindow &&
      (SessionStoreHandler.get()?.contactForm == undefined ||
        SessionStoreHandler.get()?.contactForm == true)
    ) {
      //state_showSearch.set(true);
      window.dispatchEvent(
        new CustomEvent(WindowsCustomEventTypes.toggleContactForm, {
          detail: true,
        })
      );
    }

    if (SessionStoreHandler.get()?.fullScreen) {
      //state_showSearch.set(true);
      window.dispatchEvent(
        new CustomEvent(WindowsCustomEventTypes.toggleFullScreen, {
          detail: true,
        })
      );
    }
  });

  onDestroy(() => {
    window.removeEventListener(
      WindowsCustomEventTypes.keyboardAdjust,
      handleKeyboardAdjust
    );
  });
</script>

{#if !!$ConfigStore.apiBaseUrl}
  {#if $state_showSearch}
    <div
      class={`cs-wrapper cs-chatbot cs-type-${$ConfigStore.widgetType} ${$ConfigStore.customTheme?.smallSizeThemeType === true ? 'cs-wrapper-small' : ''} ${$state_fullScreen ? 'cs-fullscreen' : ''} ${$state_showContactForm ? 'cs-bg-contact-form' : ''}
    `}
      transition:fly|global={{
        y: 50,
        duration: 1000,
      }}
      style:background={$ConfigStore.widgetType === WidgetType.cb
        ? $ConfigStore.customTheme?.bodyBg
        : $ConfigStore.customTheme?.headerBg}
      style:border-color={$ConfigStore.customTheme?.bodyBorderColor}
      style:bottom={chatbotBottom}
    >
      <ChatBotHeader />
      {#if $state_showContactForm}
        <HeaderContactTheme />
        <ContactWindow />
      {:else}
        <clever-search-chat />
      {/if}
    </div>
  {/if}
{/if}

{#if $ConfigStore.customCSSUrl}
  {#if $ConfigStore.customCSSIntegrity}
    <link
      href={$ConfigStore.customCSSUrl}
      rel="stylesheet"
      type="text/css"
      integrity={$ConfigStore.customCSSIntegrity}
      crossorigin="anonymous"
    />
  {:else}
    <link href={$ConfigStore.customCSSUrl} rel="stylesheet" type="text/css" />
  {/if}
{/if}

<style lang="scss">
  @use './scss/pages/chat-bot';
</style>
